import React from 'react';
import { useCtxParseValue } from 'helpers';
import { FasArrowUp, FasArrowDown } from 'assets/icons';
import atoms from 'ctsutheme/components/atoms';
import { BoolToString, GetEmptyValue } from 'components';
import _ from 'lodash';

const { IconButton, Typography } = atoms;

const VerifiedBy = ({ value }) => {
  const { protocolPSRVerifiedBy } = useCtxParseValue('LOV_PSR_VERIFIED_BY');
  const verified = _.find(protocolPSRVerifiedBy, { code: value });
  return <>{verified && verified.value}</>;
};


const PSRInfoColumns = [
  {
    name: 'seq',
    type: 'number',
    label: 'Sequence #',
    filterable: true,
    renderCell: (data, rowInfo) => (
      <>
        <span style={{ marginRight: '1rem' }}>
          {data.seq}
        </span>
        <Typography component="span" inline link icon>
          <IconButton
            aria-label="Move row down"
            color="inherit"
            // size="small"
            data-id="psrId"
            disabled={data.psrId === rowInfo[0]}
            onClick={() => rowInfo[2](data.psrId, 'down')}

          >
            <FasArrowDown />
          </IconButton>
        </Typography>
        {' '}
        <Typography component="span" inline link icon>
          <IconButton
            aria-label="Move row up"
            color="inherit"
            // size="small"
            data-id="nextPsr"
            disabled={data.psrId === rowInfo[1]}
            onClick={() => rowInfo[2](data.psrId, 'up')}

          >
            <FasArrowUp />
          </IconButton>
        </Typography>
      </>
    )
  },
  {
    name: 'verifiedBy',
    type: 'string',
    label: 'Verified By',
    filterable: true,
    renderCell: data => <VerifiedBy value={data.verifiedBy} />
  },
  {
    name: 'code',
    type: 'string',
    label: 'Check Value',
    filterable: true
  },
  {
    name: 'description',
    type: 'string',
    label: 'Description',
    filterable: true,
    renderCell: data => <GetEmptyValue value={data.description} />
  },
  {
    name: 'forVersionDate',
    type: 'date',
    align: 'center',
    label: 'For Version Date',
    filterable: true,
    renderCell: data => <GetEmptyValue value={data.forVersionDate} />
  },
  {
    name: 'psrType',
    type: 'string',
    label: 'PSR Type',
    filterable: true,
    renderCell: data => <GetEmptyValue value={data.psrType} />
  },
  {
    name: 'requiredByDate',
    type: 'date',
    label: 'Required By Date',
    filterable: true,
    align: 'center',
    renderCell: data => <GetEmptyValue value={data.requiredByDate} />
  },
  {
    name: 'numPersonRqdFulfillPsr',
    type: 'string',
    label: '# Persons',
    align: 'center',
    filterable: true
  },
  {
    name: 'isEvalByGroup',
    type: 'string',
    label: 'Eval By Group',
    filterable: true,
    align: 'center',
    renderCell: data => <BoolToString boolValue={data.isEvalByGroup} />
  }, 
  {
    name: 'esysStatus',
    type: 'multi',
    label: 'Status',
    align: 'center',
    optionList: [
      { label: 'ACTIVE', value: 'ACTIVE' },
      { label: 'OBSOLETE', value: 'OBSOLETE' },
      { label: 'PROPOSED', value: 'PROPOSED' }
    ]
  }
];

export default PSRInfoColumns;
